export const isAllow = user => {
  return user && user.settings
}

export default {
  isAllow,
}
